<template>
  <div
    :class="[
      'desktop-sidebar sidebar-area position-fixed start-0 top-0 bg-black h-100vh transition',
      { active: stateStoreInstance.open },
    ]"
    id="sidebar-area"
  >
    <div class="logo position-absolute start-0 end-0 top-0 bg-black">
      <div
        class="d-flex align-items-center justify-content-center"
      >
        <!-- <img src="../../assets/images/favicon.png" alt="logo-icon" /> -->
        <img class="radius-7" src="../../assets/images/LOGO_NEWTEC_CLOUD_ICONE_3.png" width="40" alt="Layer">
        <span class="fw-bold ms-10 text-white text-decoration-none title-system-name">Newtec</span>
    </div>
      <div class="border-bottom"></div>
      <button
        class="sidebar-burger-menu position-absolute lh-1 bg-transparent p-0 border-0"
        @click="handleMenuClick()"
      >
        <i class="ph-duotone ph-caret-double-right"></i>
      </button>
    </div>
    <div class="sidebar-menu">
      <ul
        class="sidebar-navbar-nav ps-0 mb-0 list-unstyled accordion"
        id="sidebarNavAccordion"
      >
        
        <li @click="handleMenuClick()" class="realtime sidebar-nav-item accordion-item bg-transparent border-0 rounded-0 mt-20">
          <router-link to="/realtime" class="accordion-button collapsed rounded-0 shadow-none bg-transparent d-block">
            <div :class="{ active: isRealtimeActive }">
              <i class="flaticon-video"></i>
              <span class="title">Mosaico de cameras</span>
            </div>
          </router-link>
        </li>

        <li @click="handleMenuClick()" class="gravacoes sidebar-nav-item accordion-item bg-transparent border-0 rounded-0">
          <router-link to="/recordings" class="accordion-button collapsed rounded-0 shadow-none bg-transparent d-block">
            <div :class="{ active: isRecordingsActive }">
              <i class="flaticon-play-button"></i>
              <span class="title">Gravações</span>
            </div>
          </router-link>
        </li>

        <li @click="handleMenuClick()" class="sidebar-nav-item accordion-item bg-transparent border-0 rounded-0">
          <router-link to="/downloads" class="accordion-button collapsed rounded-0 shadow-none bg-transparent d-block">
            <div :class="{ active: isDownloadsActive }">
              <i class="ph ph-download-simple"></i>
              <span class="title">Downloads</span>
            </div>
          </router-link>
        </li>

        <li @click="handleMenuClick()" class="cam-map sidebar-nav-item accordion-item bg-transparent border-0 rounded-0">
          <router-link to="/cam-map" class="accordion-button collapsed rounded-0 shadow-none bg-transparent d-block">
            <div :class="{ active: isCamMapActive }">
              <i class="flaticon-map"></i>
              <span class="title">Mapa de Cameras</span>
            </div>
          </router-link>
        </li>

        <li @click="handleMenuClick()" class="estacionamento sidebar-nav-item accordion-item bg-transparent border-0 rounded-0">
          <router-link to="/parking" class="accordion-button collapsed rounded-0 shadow-none bg-transparent d-block">
            <div :class="{ active: isParkingActive }">
              <i class="flaticon-track"></i>
              <span class="title">Estacionamento</span>
            </div>
          </router-link>
        </li>

        <li @click="handleMenuClick()" v-if="showOptionsAdm" class="documentacao performance sidebar-nav-item accordion-item bg-transparent border-0 rounded-0">
          <router-link to="/installation" class="accordion-button collapsed rounded-0 shadow-none bg-transparent d-block">
            <div :class="{ active: isInstallationActive }">
              <i class="flaticon-user-1"></i>
              <span class="title">Instalações / Usuários</span>
            </div>
          </router-link>
        </li>
        
        <li @click="handleMenuClick()" v-if="showOptionsAdm" class="pagamentos performance sidebar-nav-item accordion-item bg-transparent border-0 rounded-0">
          <router-link to="/payment" class="accordion-button collapsed rounded-0 shadow-none bg-transparent d-block">
            <div :class="{ active: isPaymentActive }">
              <i class="flaticon-credit-card"></i>
              <span class="title">Pagamentos</span>
            </div>
          </router-link>
        </li>

        <li @click="handleMenuClick()" v-if="showOptionsAdm" class="precos performance sidebar-nav-item accordion-item bg-transparent border-0 rounded-0">
          <router-link to="/prices" class="accordion-button collapsed rounded-0 shadow-none bg-transparent d-block">
            <div :class="{ active: isPricesActive }">
              <i class="flaticon-price-tag-2"></i>
              <span class="title">Preços</span>
            </div>
          </router-link>
        </li>

      </ul>
    </div>
  </div>

  <nav
    class="mobile-bottom-navigation has-more"
    aria-label="Navegação principal"
  >
    <router-link to="/realtime" class="mobile-navigation-item" :class="{ active: isRealtimeActive }">
      <i class="flaticon-video" aria-hidden="true"></i>
      <span>Ao vivo</span>
    </router-link>

    <router-link to="/cam-map" class="mobile-navigation-item" :class="{ active: isCamMapActive }">
      <i class="flaticon-map" aria-hidden="true"></i>
      <span>Mapa</span>
    </router-link>

    <router-link to="/recordings" class="mobile-navigation-item" :class="{ active: isRecordingsActive }">
      <i class="flaticon-play-button" aria-hidden="true"></i>
      <span>Gravações</span>
    </router-link>

    <router-link
      v-if="showOptionsAdm"
      to="/installation"
      class="mobile-navigation-item"
      :class="{ active: isInstallationActive }"
      aria-label="Instalações / Usuários"
      title="Instalações / Usuários"
    >
      <i class="ph ph-buildings" aria-hidden="true"></i>
      <span>Instalações</span>
    </router-link>

    <router-link v-else to="/parking" class="mobile-navigation-item" :class="{ active: isParkingActive }">
      <i class="flaticon-track" aria-hidden="true"></i>
      <span>Estacionamento</span>
    </router-link>

    <button
      ref="moreButton"
      type="button"
      class="mobile-navigation-item mobile-more-button"
      :class="{ active: isMoreActive || showMoreMenu }"
      aria-controls="mobileMoreMenu"
      :aria-expanded="showMoreMenu ? 'true' : 'false'"
      @click="openMoreMenu"
    >
      <i class="ph ph-dots-three-outline" aria-hidden="true"></i>
      <span>Mais</span>
    </button>
  </nav>

  <Teleport to="body">
    <Transition name="mobile-menu-sheet">
      <div
        v-if="showMoreMenu"
        id="mobileMoreMenu"
        ref="moreMenuDialog"
        class="mobile-more-menu-backdrop"
        role="dialog"
        aria-modal="true"
        aria-labelledby="mobileMoreMenuTitle"
        tabindex="-1"
        @click.self="closeMoreMenu"
        @keydown.esc="closeMoreMenu"
      >
        <section class="mobile-more-menu-sheet">
          <div class="mobile-more-menu-header">
            <div>
              <span class="mobile-more-menu-eyebrow">Navegação</span>
              <h2 id="mobileMoreMenuTitle">Mais opções</h2>
            </div>
            <button type="button" class="mobile-more-menu-close" aria-label="Fechar mais opções" @click="closeMoreMenu">
              <i class="ph ph-x" aria-hidden="true"></i>
            </button>
          </div>

          <nav class="mobile-more-menu-grid" aria-label="Mais opções de navegação">
            <router-link to="/downloads" class="mobile-more-menu-item" :class="{ active: isDownloadsActive }">
              <i class="ph ph-download-simple" aria-hidden="true"></i>
              <span>Downloads</span>
            </router-link>

            <router-link v-if="showOptionsAdm" to="/parking" class="mobile-more-menu-item" :class="{ active: isParkingActive }">
              <i class="flaticon-track" aria-hidden="true"></i>
              <span>Estacionamento</span>
            </router-link>

            <router-link v-if="showOptionsAdm" to="/payment" class="mobile-more-menu-item" :class="{ active: isPaymentActive }">
              <i class="flaticon-credit-card" aria-hidden="true"></i>
              <span>Pagamentos</span>
            </router-link>

            <router-link v-if="showOptionsAdm" to="/prices" class="mobile-more-menu-item" :class="{ active: isPricesActive }">
              <i class="flaticon-price-tag-2" aria-hidden="true"></i>
              <span>Preços</span>
            </router-link>

            <div class="mobile-more-menu-item mobile-theme-menu-item">
              <i class="flaticon-moon" aria-hidden="true"></i>
              <span>Modo escuro</span>
              <LightDarkSwtichBtn class="mobile-theme-switch" />
            </div>

            <button
              type="button"
              class="mobile-more-menu-item mobile-more-menu-logout"
              data-bs-toggle="modal"
              data-bs-target="#verticallyCenteredModal"
              @click="closeMoreMenu"
            >
              <i class="flaticon-logout" aria-hidden="true"></i>
              <span>Sair</span>
            </button>
          </nav>
        </section>
      </div>
    </Transition>
  </Teleport>
</template>

<script lang="ts">
import { defineComponent, computed, nextTick, ref, watch } from "vue";
import stateStore from "../../utils/store";
import { useRoute } from "vue-router";
import LightDarkSwtichBtn from "./LightDarkSwtichBtn.vue";

export default defineComponent({
  name: "MainSidebar",
  props: ["showOptionsAdm"],
  components: {
    LightDarkSwtichBtn,
  },
  setup() {
    const stateStoreInstance = stateStore;
    const route = useRoute();
    const showMoreMenu = ref(false);
    const moreButton = ref<HTMLElement | null>(null);
    const moreMenuDialog = ref<HTMLElement | null>(null);

    const isRecordingsActive = computed(() => route.path === '/recordings');
    const isDownloadsActive = computed(() => route.path === '/downloads');
    const isCamMapActive = computed(() => route.path === '/cam-map');
    const isRealtimeActive = computed(() => route.path === '/realtime');
    const isInstallationActive = computed(() => route.path === '/installation' || route.path.startsWith('/installation/'));
    const isPaymentActive = computed(() => route.path === '/payment');
    const isPricesActive = computed(() => route.path === '/prices');
    const isParkingActive = computed(() => route.path === '/parking');
    const isMoreActive = computed(() => [
      '/parking',
      '/payment',
      '/prices',
      '/downloads'
    ].some((path) => route.path === path || route.path.startsWith(`${path}/`)));

    const openMoreMenu = async () => {
      showMoreMenu.value = true;
      await nextTick();
      moreMenuDialog.value?.focus();
    };

    const closeMoreMenu = () => {
      showMoreMenu.value = false;
    };

    watch(() => route.path, closeMoreMenu);

    const handleMenuClick = () => {
      if (window.innerWidth <= 768) {
        stateStoreInstance.onChange();
      }
    };

    return {
      stateStoreInstance,
      isRecordingsActive,
      isDownloadsActive,
      isCamMapActive,
      isRealtimeActive,
      isInstallationActive,
      isPaymentActive,
      isPricesActive,
      isParkingActive,
      isMoreActive,
      showMoreMenu,
      moreButton,
      moreMenuDialog,
      openMoreMenu,
      closeMoreMenu,
      handleMenuClick
    };
  },
});
</script>
<style scoped>
.active {
  color: #fff;
}

.title-system-name{
  font-size: 18pt;
}

.mobile-bottom-navigation {
  display: none;
}

@media (max-width: 767px) {
  .desktop-sidebar {
    display: none !important;
  }

  .mobile-bottom-navigation {
    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1080;
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    height: calc(64px + env(safe-area-inset-bottom));
    padding: 5px 4px env(safe-area-inset-bottom);
    border-top: 1px solid #e5e6ef;
    background: rgba(255, 255, 255, 0.98);
    box-shadow: 0 -2px 8px rgba(43, 42, 63, 0.06);
    backdrop-filter: blur(12px);
  }

  .mobile-bottom-navigation.has-more {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .mobile-navigation-item {
    position: relative;
    display: flex;
    min-width: 0;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 3px;
    padding: 5px 2px;
    border: 0;
    border-radius: 9px;
    color: #77778d;
    background: transparent;
    font-family: inherit;
    font-size: 10px;
    font-weight: 600;
    line-height: 1.15;
    text-align: center;
    text-decoration: none;
    -webkit-tap-highlight-color: transparent;
  }

  .mobile-navigation-item i {
    font-size: 20px;
    line-height: 1;
  }

  .mobile-navigation-item span {
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .mobile-navigation-item.active {
    color: #5d5fef;
    background-color: #f2f1ff;
  }

  .mobile-navigation-item.active::before {
    position: absolute;
    top: -5px;
    width: 28px;
    height: 3px;
    border-radius: 0 0 3px 3px;
    background-color: #5d5fef;
    content: "";
  }

  .mobile-more-button {
    width: 100%;
    cursor: pointer;
  }

  .mobile-more-button i {
    font-size: 23px;
  }

  .mobile-more-menu-backdrop {
    position: fixed;
    inset: 0;
    z-index: 1090;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    padding: 16px 8px 0;
    background-color: rgba(29, 28, 45, 0.46);
    backdrop-filter: blur(2px);
  }

  .mobile-more-menu-sheet {
    width: 100%;
    max-width: 520px;
    padding: 18px 16px calc(18px + env(safe-area-inset-bottom));
    border-radius: 18px 18px 0 0;
    background-color: #fff;
    box-shadow: 0 -12px 34px rgba(29, 28, 45, 0.18);
  }

  .mobile-more-menu-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 14px;
  }

  .mobile-more-menu-eyebrow {
    display: block;
    margin-bottom: 2px;
    color: #8a8aa3;
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.08em;
    text-transform: uppercase;
  }

  .mobile-more-menu-header h2 {
    margin: 0;
    color: #2b2a3f;
    font-size: 19px;
    line-height: 1.3;
  }

  .mobile-more-menu-close {
    display: inline-flex;
    width: 40px;
    height: 40px;
    align-items: center;
    justify-content: center;
    padding: 0;
    border: 0;
    border-radius: 50%;
    color: #5f6075;
    background-color: #f1f2f7;
    font-size: 20px;
  }

  .mobile-more-menu-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
  }

  .mobile-more-menu-item {
    display: flex;
    min-width: 0;
    min-height: 68px;
    align-items: center;
    gap: 11px;
    padding: 12px;
    border: 1px solid #e8e8f2;
    border-radius: 11px;
    color: #45445e;
    background-color: #fafafd;
    font-size: 12px;
    font-weight: 600;
    line-height: 1.3;
    text-decoration: none;
  }

  .mobile-more-menu-logout {
    width: 100%;
    font-family: inherit;
    text-align: left;
    cursor: pointer;
  }

  .mobile-theme-menu-item {
    cursor: default;
  }

  .mobile-theme-switch {
    flex: 0 0 auto;
    margin-left: auto;
  }

  :deep(.mobile-theme-switch .switch-toggle) {
    display: inline-flex !important;
    width: 38px !important;
    height: 38px !important;
    align-items: center;
    justify-content: center;
    padding: 0;
    color: #5d5fef;
    background-color: #eeedff;
    font-size: 17px;
  }

  :global(.dark) .mobile-theme-menu-item {
    border-color: #45445e;
    color: #fff;
    background-color: #343348;
  }

  :global(.dark) .mobile-more-menu-sheet {
    background-color: #2b2a3f;
  }

  :global(.dark) .mobile-more-menu-header h2 {
    color: #fff;
  }

  .mobile-more-menu-item:last-child:nth-child(odd) {
    grid-column: 1 / -1;
  }

  .mobile-more-menu-item i {
    flex: 0 0 auto;
    color: #5d5fef;
    font-size: 21px;
  }

  .mobile-more-menu-item span {
    min-width: 0;
    overflow-wrap: anywhere;
  }

  .mobile-more-menu-item.active {
    border-color: #bfc0ff;
    color: #4c4ed5;
    background-color: #f2f1ff;
  }

  .mobile-menu-sheet-enter-active,
  .mobile-menu-sheet-leave-active {
    transition: opacity 180ms ease;
  }

  .mobile-menu-sheet-enter-active .mobile-more-menu-sheet,
  .mobile-menu-sheet-leave-active .mobile-more-menu-sheet {
    transition: transform 180ms ease;
  }

  .mobile-menu-sheet-enter-from,
  .mobile-menu-sheet-leave-to {
    opacity: 0;
  }

  .mobile-menu-sheet-enter-from .mobile-more-menu-sheet,
  .mobile-menu-sheet-leave-to .mobile-more-menu-sheet {
    transform: translateY(24px);
  }
}
</style>
